import styled from 'styled-components';

export const StyledForm = styled.form`
  width: 100%;
`;

// ── "Need a hand?" contact card ───────────────────────────────────────────────

export const StyledNeedHelpCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--s-5);
  flex-wrap: wrap;
  padding: var(--s-5) var(--s-6);
  border-radius: var(--r-lg);
  background: linear-gradient(135deg, var(--success-soft) 0%, #FBFAF7 60%);
  border: 1px solid rgba(45, 170, 102, 0.15);
  margin-bottom: var(--s-5);
`;

export const StyledNeedHelpBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s-1);
  min-width: 0;
`;

export const StyledNeedHelpTitle = styled.h3`
  margin: 0;
  font-size: var(--t-base);
  font-weight: var(--weight-semibold);
  color: var(--brand-green-ink);
`;

export const StyledNeedHelpDesc = styled.p`
  margin: 0;
  font-size: var(--t-sm);
  color: var(--brand-green-ink);
  opacity: 0.8;
  max-width: 36rem;
`;

export const StyledNeedHelpHours = styled.p`
  margin: var(--s-1) 0 0;
  font-size: var(--t-xs);
  font-weight: var(--weight-medium);
  color: var(--brand-green-ink);
  opacity: 0.65;
`;

export const StyledNeedHelpActions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s-3);
  flex-shrink: 0;
`;

export const StyledNeedHelpWhatsApp = styled.a`
  display: inline-flex;
  align-items: center;
  gap: var(--s-2);
  height: 36px;
  padding: 0 var(--s-4);
  border-radius: var(--r-sm);
  font-size: var(--t-sm);
  font-weight: var(--weight-medium);
  color: var(--brand-green-ink);
  background: transparent;
  border: 1.5px solid var(--brand-green);
  text-decoration: none;
  transition: background var(--dur-fast) var(--ease-out);

  &:hover {
    background: var(--brand-green-soft);
    filter: brightness(0.96);
  }

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;

export const StyledNeedHelpChat = styled.a`
  display: inline-flex;
  align-items: center;
  gap: var(--s-2);

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
  height: 36px;
  padding: 0 var(--s-4);
  border-radius: var(--r-sm);
  font-size: var(--t-sm);
  font-weight: var(--weight-medium);
  color: var(--surface);
  background: var(--brand-ink);
  text-decoration: none;
  transition: opacity var(--dur-fast) var(--ease-out);

  &:hover {
    opacity: 0.88;
  }
`;

export const StyledSearchWrapper = styled.div`
  width: 100%;
  max-width: 28rem;
`;

export const StyledFaqHero = styled.section`
  position: relative;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.25rem;
  border-radius: var(--r-lg);
  background: linear-gradient(
    135deg,
    rgba(9, 15, 56, 0.04) 0%,
    rgba(118, 177, 89, 0.05) 100%
  );
  border: 1px solid rgba(9, 15, 56, 0.07);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -2.5rem;
    right: -3rem;
    width: 9rem;
    height: 9rem;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 280' fill='none'><g stroke='%23090F38' stroke-width='1.6' stroke-linejoin='round' stroke-linecap='round' opacity='0.22'><path d='M40 80l60-30 60 30v60l-60 30-60-30z'/><path d='M40 80l60 30M160 80l-60 30M100 110v60'/></g></svg>");
    background-repeat: no-repeat;
    background-size: contain;
    opacity: 0.55;
    pointer-events: none;
    -webkit-mask-image: linear-gradient(225deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 75%);
    mask-image: linear-gradient(225deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 75%);
  }
  > * {
    position: relative;
    z-index: 1;
  }
`;

export const StyledFaqHeroTitle = styled.h2`
  margin: 0 0 0.375rem;
  font-size: var(--t-xl);
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-tight);
  color: var(--ink);
`;

export const StyledFaqHeroSub = styled.p`
  margin: 0;
  max-width: 44rem;
  font-size: var(--t-base);
  color: var(--muted);
  line-height: 1.5;
`;

export const StyledCategory = styled.section`
  padding: 1rem 0 0;

  & + & {
    margin-top: 0.75rem;
    border-top: 1px solid var(--line);
  }
`;

export const StyledCategoryTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.25rem;
  font-size: var(--t-base);
  font-weight: var(--weight-semibold);
  letter-spacing: -0.005em;
  color: var(--ink);

  &::before {
    content: '';
    width: 3px;
    height: 0.875rem;
    background: var(--brand-green);
    border-radius: 2px;
    flex-shrink: 0;
  }
`;

export const StyledCategoryDescription = styled.p`
  margin: 0 0 0.5rem;
  font-size: 0.8125rem;
  color: var(--muted-2);
`;

export const StyledQuestionItem = styled.div`
  border-bottom: 1px solid var(--line);
  &:last-child {
    border-bottom: 0;
  }
`;

export const StyledQuestionHeader = styled.button<{ open?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.875rem 0;
  background: transparent;
  border: 0;
  text-align: left;
  font: inherit;
  font-size: var(--t-base);
  font-weight: var(--weight-medium);
  color: var(--ink);
  cursor: pointer;
  transition: color var(--dur-fast) var(--ease-out);

  svg {
    width: 1rem;
    height: 1rem;
    color: var(--muted-2);
    transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1);
    transform: rotate(${({ open }) => (open ? '180deg' : '0deg')});
    flex-shrink: 0;
    margin-inline-start: 0.75rem;
  }
`;

export const StyledQuestionAnswer = styled.div<{ open?: boolean }>`
  max-height: ${({ open }) => (open ? '40rem' : '0')};
  overflow: hidden;
  transition: max-height 240ms cubic-bezier(0.4, 0, 0.2, 1),
    padding 200ms cubic-bezier(0.4, 0, 0.2, 1);
  padding-bottom: ${({ open }) => (open ? '1rem' : '0')};

  p,
  div {
    font-size: var(--t-sm);
    color: var(--muted);
    line-height: 1.55;
    margin: 0;
  }
  strong {
    color: var(--ink);
    font-weight: var(--weight-semibold);
  }
  a {
    color: var(--brand-green-ink);
    text-decoration: none;
    border-bottom: 1px solid rgba(118, 177, 89, 0.4);
    &:hover {
      border-bottom-color: var(--brand-green);
    }
  }
`;

export const StyledFaqEmpty = styled.div`
  padding: 2rem 1rem;
  text-align: center;
  color: var(--muted-2);
  font-size: var(--t-base);
`;

export const StyledFaqContactCTA = styled.aside`
  margin-top: 1.5rem;
  padding: 1rem 1.25rem;
  border-radius: var(--r-lg);
  background-color: rgba(9, 15, 56, 0.03);
  border: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;

  strong {
    font-size: var(--t-base);
    font-weight: var(--weight-semibold);
    color: var(--ink);
  }

  small {
    display: block;
    margin-top: 0.125rem;
    font-size: 0.8125rem;
    color: var(--muted);
  }

  a {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    height: 2.25rem;
    padding: 0 0.875rem;
    background-color: var(--brand-ink);
    color: var(--surface);
    border-radius: var(--r-sm);
    font-size: 0.8125rem;
    font-weight: var(--weight-medium);
    text-decoration: none;
    transition: opacity var(--dur-fast) var(--ease-out);
    &:hover {
      opacity: 0.88;
    }
  }
`;
